var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIncreaseIc = function SvgIncreaseIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.27 12-.934-.933L6.269 6.1l2.667 2.667 3.467-3.434h-1.734V4h4v4h-1.333V6.267l-4.4 4.4L6.269 8l-4 4Z",
    fill: "#41C9B4"
  })));
};

export default SvgIncreaseIc;